// Common E.164 country codes
const COUNTRY_CODES = [
  // 1-digit
  "+1",

  // 2-digit
  "+20",
  "+27",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+36",
  "+39",
  "+40",
  "+41",
  "+43",
  "+44",
  "+45",
  "+46",
  "+47",
  "+48",
  "+49",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+81",
  "+82",
  "+84",
  "+86",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+98",

  // 3-digit
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+380",
  "+381",
  "+382",
  "+385",
  "+386",
  "+387",
  "+389",
  "+420",
  "+421",
  "+423",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+590",
  "+591",
  "+592",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+599",
];

export function maskPhoneNumber(phone?: string): string {
  if (!phone) {
    return "";
  }

  // 1. Remove spaces, dashes, and parentheses
  const cleaned = phone.replace(/[\s\-()]/g, "");

  // 2. Try to detect a valid country code from known list
  const foundCode = COUNTRY_CODES.find((code) => cleaned.startsWith(code));

  if (foundCode) {
    const rest = cleaned.slice(foundCode.length);

    // If the rest is too short to mask, just return as-is
    if (rest.length <= 2) {
      return `${foundCode}${rest}`;
    }

    const visibleTail = rest.slice(-2);
    const maskedSection = "*".repeat(rest.length - 2);
    return `${foundCode}${maskedSection}${visibleTail}`;
  }

  // 3. Fallback (no country code) → show first 2 and last 2 digits
  const digits = cleaned.replace(/\D/g, "");
  if (digits.length <= 4) {
    return digits;
  }

  const visibleHead = digits.slice(0, 2);
  const visibleTail = digits.slice(-2);
  const maskedSection = "*".repeat(digits.length - 4);

  return `${visibleHead}${maskedSection}${visibleTail}`;
}
